"use client";

import { SLLanguageSwitcher } from "@/components/i18n/SLLanguageSwitcher";
import { SLDialogTerminBuchen } from "@/components/dialogs/SLDialogTerminBuchen";
import { useMessages } from "@/lib/i18n/useMessages";
import { Close, Menu as MenuIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

export function SLNavigationMobileDrawer({
  burgerOpen,
  onBurgerOpen,
  onBurgerClose,
  openTerminBuchen,
  onOpenTerminBuchen,
  onCloseTerminBuchen,
  navItems,
}: {
  burgerOpen: boolean;
  onBurgerOpen: () => void;
  onBurgerClose: () => void;
  openTerminBuchen: boolean;
  onOpenTerminBuchen: () => void;
  onCloseTerminBuchen: () => void;
  navItems: React.ReactNode;
}) {
  const theme = useTheme();
  const m = useMessages();
  const navMobile = m.nav.mobile;
  const bookFreeCta = m.dialogs.buttonGroup.bookFreeInitialConsultation;

  return (
    <>
      <Stack
        sx={{
          width: "fit-content",
          height: "100%",
          alignSelf: "center",
          justifySelf: "center",
        }}
      >
        <IconButton
          onClick={onBurgerOpen}
          aria-label={navMobile.openMenuAria}
          aria-expanded={burgerOpen}
          aria-controls="mobile-menu-dialog"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.text.primary,
            height: "80px",
            aspectRatio: "1/1",
            alignSelf: "center",
            justifySelf: "center",
          }}
        >
          <MenuIcon sx={{ height: "100%", width: "100%", p: 1 }} />
        </IconButton>
      </Stack>

      <Dialog
        open={burgerOpen}
        onClose={onBurgerClose}
        fullScreen
        id="mobile-menu-dialog"
        aria-labelledby="mobile-menu-title"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              zIndex: 1,
            }}
          >
            <SLLanguageSwitcher variant="icon" />
            <IconButton
              onClick={onBurgerClose}
              aria-label={navMobile.closeMenuAria}
              size="large"
              sx={{
                color: theme.palette.text.primary,
              }}
            >
              <Close fontSize="large" />
            </IconButton>
          </Box>

          <Typography
            id="mobile-menu-title"
            sx={{ position: "absolute", left: "-10000px" }}
          >
            Navigation Menu
          </Typography>

          <Stack spacing={3} sx={{ width: "100%", maxWidth: "400px" }}>
            {navItems}
            <Button
              variant="text"
              color="primary"
              onClick={onOpenTerminBuchen}
              size="medium"
              sx={{
                width: "100%",
                display: "flex",
                alignSelf: "center",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: theme.palette.text.primary,
              }}
            >
              {bookFreeCta}
            </Button>
            <SLDialogTerminBuchen
              handleClose={onCloseTerminBuchen}
              open={openTerminBuchen}
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
